import React, { useEffect, useState } from 'react';
import '../ProductDetailPage/Styles.css';
import ContactSection from '../../../components/ContactSectionPage/Index';
import useTitle from '../../../useTitle';
import { useParams } from 'react-router-dom';
import { getProductBySlug } from '../../../components/sanityProject/sanityData';
import { urlFor } from '../../../components/sanityProject/imageUrl';

const ProductDetail = () => {
  const { slug } = useParams();

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState('');
  const [images, setImages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useTitle(product ? product.title : "Product Detail");

  useEffect(() => {
    getProductBySlug(slug).then(data => {
      setProduct(data);

      const imgs = [
        urlFor(data.mainImage).url(),
        data.secondImage && urlFor(data.secondImage).url(),
        data.thirdImage && urlFor(data.thirdImage).url(),
      ].filter(Boolean);

      setImages(imgs);
      setCurrentIndex(0);          
      setMainImage(imgs[0]);       
    });
  }, [slug]);

  const changeImage = (src, index) => {
    setMainImage(src);
    setCurrentIndex(index);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(newIndex);
    setMainImage(images[newIndex]);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentIndex(newIndex);
    setMainImage(images[newIndex]);
  };

  if (!product) return <div className='productDetailContainer'></div>;

  return (
    <>
      <div className='productDetailContainer'>
        <div className='productDetail'>

          {/* GALLERY */}
          <div className="product-gallery">
            <img
              src={mainImage}
              className="productDetailImage"
              alt={product.title}
              onClick={() => setIsOpen(true)}
            />

            <div className="thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  onClick={() => changeImage(img, index)}
                  className={currentIndex === index ? "active-thumb" : ""}
                  alt="product"
                />
              ))}
            </div>
          </div>

          {/* INFO */}
          <div className='productInformationSection'>
            <div className='productDetailTitleSection'>
              <h1 className='productDetailTitle'>{product.title}</h1>
            </div>

            <div className='productDetailPriceSection'>
              <p>€ {product.price.toFixed(2)}</p>
            </div>

            <div className='productDetailDescriptionSection'>
              <p>{product.description}</p>
              <p>{product.ringSize}</p>
            </div>

            <div className='productInquireButtonSection'>
              <a href='/contact' className='productInquireButton'>
                Inquire now
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* LIGHTBOX */}
      {isOpen && (
        <div className="lightbox" onClick={() => setIsOpen(false)}>
          <span className="close">&times;</span>

          <img src={images[currentIndex]} className="lightbox-img" alt="" />

          <button className="prev" onClick={prevImage}>❮</button>
          <button className="next" onClick={nextImage}>❯</button>
        </div>
      )}

      <ContactSection />
    </>
  );
};

export default ProductDetail;